document.addEventListener('DOMContentLoaded', () => {
    let size_chart_data = document.querySelector('.size-chart__container');
    let bodyElement = document.querySelector('.template-product');
    let newSizeChartContainer = document.createElement('div');

    newSizeChartContainer.classList.add('size-chart__wrapper');
    newSizeChartContainer.innerHTML = size_chart_data.dataset.content;
    bodyElement.appendChild(newSizeChartContainer);

    let innerSizeChart = newSizeChartContainer.querySelector('.size-chart__page');

    let anchorElement = document.querySelector('.size-chart');
    anchorElement.addEventListener('click', () => {
        newSizeChartContainer.style.visibility="visible";
        newSizeChartContainer.style.opacity="1";
        newSizeChartContainer.style.zIndex="9999100105";

        innerSizeChart.style.transition="visibility 0.4s ease-in, opacity 0.4s ease-in, transform 0.4s ease-in";
        innerSizeChart.style.opacity="1";
        innerSizeChart.style.visibility="visible";
        innerSizeChart.style.transform="translate(-50%, 0%) scale(1)";
        closeModal();
    })

    let iconClose = newSizeChartContainer.querySelector('.size-chart__close span');
    iconClose.addEventListener('click', () => {
        closeHandler();
    })

    const closeModal = () => {
        newSizeChartContainer.addEventListener('click', (e) => {
            if(!innerSizeChart.contains(e.target)){
                closeHandler();
            }
        })
    }

    const closeHandler = () => {
        newSizeChartContainer.style.visibility="hidden";
        newSizeChartContainer.style.opacity="0";
        newSizeChartContainer.style.zIndex="-1";

        innerSizeChart.style.opacity="0";
        innerSizeChart.style.visibility="hidden";
        innerSizeChart.style.transform="translate(-50%, 0) scale(.5)";
    }
    
})